import React from "react";
import { Link } from "react-router-dom";
import NewsletterForm from "../components/NewsletterForm";
import ProductForm from "../components/ProductForm";
import PipedriveForm from "../components/PipedriveForm";
import LeadForm from "../components/LeadForm";

const Footer: React.FC = () => {
  return (
      <footer className="bg-black text-white">
        <div className="mx-auto max-w-7xl px-6 py-10">
          {/* ROW principale */}
          <div className="grid grid-cols-1 md:grid-cols-12 gap-x-8 gap-y-8 items-start">

            {/* Colonna 1: Logo + Social */}
            <div className="md:col-span-3 space-y-4">
              <Link to="/home" className="inline-block">
                <img
                    src="/REVOLV - logo with claim.png"
                    alt="Revolv Space"
                    className="h-10 w-auto md:h-12"
                    loading="lazy"
                />
              </Link>
              {/* Social Media Icons */}
              <div className="flex items-center gap-3">
                <Link
                    to="https://www.linkedin.com/company/75425254"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="LinkedIn"
                    className="opacity-90 hover:opacity-100 transition"
                >
                  <img src="/footer_icons/Group.svg" alt="LinkedIn" className="h-6 w-6" />
                </Link>
              </div>
            </div>

            {/* Colonna 2: Menu A */}
            <nav className="md:col-span-3">
              <ul className="text-sm leading-snug tracking-wide space-y-2">
                <li><a href="/home" className="hover:text-gray-300 transition">HOME</a></li>
                <li><a href="/about" className="hover:text-gray-300 transition">ABOUT</a></li>
              <li><a href="/careers" className="hover:text-gray-300 transition">CAREERS</a></li>
              <li><a href="/news" className="hover:text-gray-300 transition">NEWS</a></li>
              <li><a href="/contact" className="hover:text-gray-300 transition">CONTACT</a></li>

              </ul>
            </nav>

            {/* Colonna 3: Menu B PRODUCTS */}
            <nav className="md:col-span-3">
              <ul className="text-sm leading-snug tracking-wide space-y-2">
                  <li className="uppercase font-bold text-white/90 pt-2">Products</li>
                  <li><a href="/products/Sara" className="hover:text-gray-300 transition">SARA</a></li>
                  <li><a href="/products/Holly" className="hover:text-gray-300 transition">HOLLY</a></li>
                  <li><a href="/products/Mara" className="hover:text-gray-300 transition">MARA</a></li>
                  <li><a href="/products/Pavel" className="hover:text-gray-300 transition">PAVEL</a></li>
                  <li><a href="/products/Kimball" className="hover:text-gray-300 transition">KIMBALL</a></li>
              </ul>
            </nav>

            {/* Colonna 4: Indirizzi (compatti) */}
            <div className="md:col-span-3 grid grid-cols-1 gap-6 text-sm leading-snug ">
              <div>
                <h3 className="uppercase font-bold mb-1">Revolv Space SRL</h3>
                <p className="uppercase text-white/80 text-xs">
                  Corso Re Umberto 7<br />
                  10121 Torino<br />
                  Italy<br />
                  IT1278530013
                </p>
              </div>
              <div>
                <h3 className="uppercase font-bold mb-1">Revolv Space BV</h3>
                <p className="uppercase text-white/80 text-xs">
                  Coenderstraat 5<br />
                  2613 SM Delft<br />
                  The Netherlands<br />
                  NL863850017B01
                </p>
              </div>
            </div>
          </div>

          {/* Bottom bar sottile */}
          <div className="mt-8 border-t border-white/10 pt-4 text-xs text-white/60 flex items-center justify-between">
            <span>© {new Date().getFullYear()} Revolv Space. All rights reserved.</span>
            <div className="flex items-center gap-5">
              <a href="https://www.privacylab.it/informativa.php?23524513140&lang=en" className="hover:text-gray-300 transition">Privacy Policy</a>
            </div>
          </div>
        </div>
      </footer>


  );
};

export default Footer;
